import type { FieldErrors } from "react-hook-form";

import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export type RateErrors = FieldErrors<StepTicketsFormData>["rates"];
export type RateError = NonNullable<RateErrors>[number];

export const getRateErrorEntries = (rateErrors: RateErrors): [number, RateError][] => {
  if (!rateErrors) {
    return [];
  }
  if (Array.isArray(rateErrors)) {
    return rateErrors.flatMap((error: RateError, index) => (error ? [[index, error] as [number, RateError]] : []));
  }
  return Object.entries(rateErrors)
    .filter(([key, error]) => !Number.isNaN(Number(key)) && Boolean(error))
    .map(([key, error]) => [Number(key), error as RateError] as [number, RateError])
    .sort(([indexA], [indexB]) => indexA - indexB);
};
